/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UmbrellaCompanyResource } from './';
import {
    UmbrellaCompanyResourceFromJSON,
    UmbrellaCompanyResourceFromJSONTyped,
    UmbrellaCompanyResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface JoinUmbrellaApplication
 */
export interface JoinUmbrellaApplication {
    /**
     * 
     * @type {UmbrellaCompanyResource}
     * @memberof JoinUmbrellaApplication
     */
    umbrella: UmbrellaCompanyResource;
    /**
     * 
     * @type {string}
     * @memberof JoinUmbrellaApplication
     */
    state: JoinUmbrellaApplicationStateEnum;
}


/**
 * @export
 */
export const JoinUmbrellaApplicationStateEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Refused: 'REFUSED'
} as const;
export type JoinUmbrellaApplicationStateEnum = typeof JoinUmbrellaApplicationStateEnum[keyof typeof JoinUmbrellaApplicationStateEnum];


/**
 * Check if a given object implements the JoinUmbrellaApplication interface.
 */
export function instanceOfJoinUmbrellaApplication(value: object): value is JoinUmbrellaApplication {
    if (!('umbrella' in value) || value['umbrella'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function JoinUmbrellaApplicationFromJSON(json: any): JoinUmbrellaApplication {
    return JoinUmbrellaApplicationFromJSONTyped(json, false);
}

export function JoinUmbrellaApplicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinUmbrellaApplication {
    if (json == null) {
        return json;
    }
    return {
        
        'umbrella': UmbrellaCompanyResourceFromJSON(json['umbrella']),
        'state': json['state'],
    };
}

export function JoinUmbrellaApplicationToJSON(value?: JoinUmbrellaApplication | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'umbrella': UmbrellaCompanyResourceToJSON(value['umbrella']),
        'state': value['state'],
    };
}

